if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.errorHtml = this.querySelector('template')?.content.firstElementChild?.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.requestId = 0;
      if (this.hasAttribute('available')) this.fetchAvailability(this.dataset.variantId);
    }

    disconnectedCallback() {
      this.cancelRequest();
      this.clearDrawer();
    }

    cancelRequest() {
      this.requestId += 1;
      this.abortController?.abort();
    }

    clearDrawer() {
      const drawer = this.drawer;
      this.drawer = null;
      if (drawer?.open && typeof drawer.hide === 'function') {
        Promise.resolve(drawer.hide()).finally(() => drawer.remove());
      } else {
        drawer?.remove();
      }
    }

    hidePreview() {
      this.innerHTML = '';
      this.removeAttribute('available');
      this.hidden = true;
      this.clearDrawer();
    }

    async fetchAvailability(variantId) {
      this.cancelRequest();
      this.hidePreview();
      if (!variantId) return;
      this.dataset.variantId = String(variantId);
      const requestId = this.requestId;
      this.abortController = new AbortController();
      const rootUrl = (this.dataset.rootUrl || '/').replace(/\/?$/, '/');
      const url = `${rootUrl}variants/${encodeURIComponent(variantId)}/?section_id=pickup-availability`;
      try {
        const response = await fetch(url, { signal: this.abortController.signal });
        if (!response.ok) throw new Error('Pickup availability request failed');
        const text = await response.text();
        if (requestId !== this.requestId || !this.isConnected) return;
        const section = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        if (!section) throw new Error('Pickup availability section missing');
        this.renderPreview(section);
      } catch (error) {
        if (error.name === 'AbortError' || requestId !== this.requestId || !this.isConnected) return;
        this.renderError();
      }
    }

    onClickRefreshList() {
      this.fetchAvailability(this.dataset.variantId);
    }

    update(variant) {
      this.dataset.variantId = variant?.id ? String(variant.id) : '';
      if (variant?.available) {
        this.fetchAvailability(variant.id);
      } else {
        this.cancelRequest();
        this.hidePreview();
      }
    }

    renderError() {
      this.hidePreview();
      if (!this.errorHtml) return;
      this.appendChild(this.errorHtml.cloneNode(true));
      this.hidden = false;
      this.querySelector('button')?.addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(section) {
      const preview = section.querySelector('.pickup-availability-preview');
      const drawer = section.querySelector('.pickup-availability-drawer');
      this.hidePreview();
      if (!preview || !drawer) return;
      this.appendChild(preview);
      const drawerId = this.id ? `${this.id}-Drawer` : 'PickupAvailability';
      [preview, drawer].forEach(container => container.querySelectorAll('[aria-controls="PickupAvailability"]').forEach(control => control.setAttribute('aria-controls', drawerId)));
      drawer.id = drawerId;
      this.drawer = drawer;
      document.body.appendChild(drawer);
      this.hidden = false;
      this.setAttribute('available', '');
    }
  });
}

